import React from 'react';
import styles from '../juliagarciabeauty/juliagarciabeauty.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado from '../../components/LinkPersonalizado/linkPersonalizado.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import cursoPdf from './src/curso.pdf';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MagazineIcon from '../../icons/magazineIcon.tsx';

const Juliagarciabeauty: React.FC = () => {

    return (
        <div className={styles.juliagarciabeauty}>
            <div className={styles["body-thunder"]}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mb-0">JULIA GARCIA</h1>
                    <p className="mb-0">Designer de sobracelhas</p>
                    <p className="mb-3">Lash design</p>
                    <div className={styles.links}>
                        <LinkPersonalizado
                            href="https://wa.me/5517996780851?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20horário."
                            title="Agendamento"
                            icon={<WhatsappIcon height="40" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://wa.me/5517996780851?text=Olá, gostaria de mais informações sobre o curso."
                            title="Informações para curso"
                            icon={<MagazineIcon height="32" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://maps.app.goo.gl/7RbGRXd4iMQy6ioP6"
                            title="Localização"
                            icon={<MapsIcon height="40" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href={cursoPdf}
                            title="Catálogo"
                            icon={<CatalogIcon height="32" color="#d6ad58" />}
                            colorText="#000"
                        />
                        <LinkPersonalizado
                            href="https://www.instagram.com/juliagarciabeauty?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            icon={<InstagramIcon height="32" color="#d6ad58" />}
                            colorText="#000"
                        />
                    </div>
                    <div className="mt-4">
                        <img width={250} src={require("./src/logo_footer.png")} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Juliagarciabeauty;
